import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { InputComponent } from '../../../shared/input/input.component';
import { InputSelectComponent } from '../../../shared/input-select/input-select.component';
import { InputMockComponent } from '../../../shared/input-mock/input-mock.component';
import { getHeroName, HeroReport } from '../../../model/hero-report/hero-report.model';

@Component({
  selector: 'app-incident-report-step1',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputComponent,
    InputSelectComponent,
    InputMockComponent
  ],
  templateUrl: './incident-report-step1.component.html'
})
export class IncidentReportStep1Component {
  @Input() formGroup!: FormGroup;
  @Input() heroReport!: HeroReport;
  @Output() onFormSubmit = new EventEmitter<any>();

  incidentTypeOptions = [
    { label: $localize`:@@incidentType.unusual:Unusual`, value: 'UNUSUAL' },
    { label: $localize`:@@incidentType.routine:Routine`, value: 'ROUTINE' }
  ];

  submit() {
    if (this.formGroup.value.incidentType === '') {
      this.formGroup.patchValue({ incidentType: null });
    }
    this.onFormSubmit.emit(this.formGroup.value);
  }

  openDirections() {
    const { latitude, longitude } = this.heroReport;
    if (latitude != null && longitude != null) {
      window.open(
        `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`,
        '_blank'
      );
    }
  }

  protected readonly getHeroName = getHeroName;
}
